export * from './People1MinusIcon';
export * from './People1MinusIcon16Light';
export * from './People1MinusIcon16Regular';
export * from './People1MinusIcon16Solid';
export * from './People1MinusIcon20Light';
export * from './People1MinusIcon20Regular';
export * from './People1MinusIcon20Solid';
export * from './People1MinusIcon24Regular';
export * from './People1MinusIcon24Solid';
export * from './People1MinusIcon32Regular';
export * from './People1MinusIcon64Regular';
